import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText, Divider, ListSubheader, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from '@application/utilities/i18n';
const LanguageMenu = ({ anchorEl, open, onClose, selectedLang, onChangeLang, languages }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const handleLanguageChange = (lang) => {
        onChangeLang(lang);
        i18n.changeLanguage(lang.code);
        onClose();
    };
    return (_jsxs(Menu, { anchorEl: anchorEl, open: open, onClose: onClose, anchorOrigin: { vertical: 'top', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, PaperProps: {
            sx: {
                mt: 0,
                ml: 1,
                minWidth: 220,
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                border: '1px solid rgba(0,0,0,0.08)',
                '& .MuiMenuItem-root': { px: 2 }
            }
        }, children: [_jsx(ListSubheader, { sx: {
                    fontSize: '12px',
                    fontWeight: 600,
                    color: theme.palette.grey[500],
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    px: 2,
                    py: 1,
                    backgroundColor: 'transparent'
                }, children: t('common.selectLanguage') }), _jsx(Divider, { sx: { mx: 1, my: 0.5 } }), languages.map((lang, index) => (_jsxs(React.Fragment, { children: [_jsxs(MenuItem, { onClick: () => {
                            handleLanguageChange(lang);
                            onClose();
                        }, selected: lang.code === selectedLang.code, sx: { '&:hover': { backgroundColor: theme.palette.grey[50] } }, children: [_jsx(ListItemIcon, { children: _jsx("img", { src: lang.flag, alt: lang.textKey, width: 20, height: 15, style: { borderRadius: 2 } }) }), _jsx(ListItemText, { primary: t(lang.textKey), sx: {
                                    '& .MuiListItemText-primary': {
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        color: theme.palette.grey[800]
                                    }
                                } })] }), index < languages.length - 1 && _jsx(Divider, { sx: { mx: 1, my: 0.5 } })] }, lang.code)))] }));
};
export default LanguageMenu;
